module.exports = __webpack_public_path__ + "media/images/leaflet_images/layers-2x-4f0283c6ce28e888000e978e537a6a56.png";